import HorizontalBar from "./HorizontalBar";

export default HorizontalBar;
